import {
  Spacing,
  MediaQueries
} from 'UI'

export default theme => ({
  navbar: {
    position: 'sticky',
    height: 86,
    width: '100%',
    zIndex: 999,
    top: ({ topBarOpen }) => topBarOpen ? 60 : 0,
    background: theme.neutral[400],
    transform: ({ show }) => show ? 'translateY(0px)' : 'translateY(-100px)',
    opacity: ({ show }) => show ? 1 : 0,
    transition: 'all 0.3s cubic-bezier(0.39, 0.58, 0.57, 1)'
  },
  noMaxWidth: {
    maxWidth: ({ isFrance, isElligableForTrial }) => isFrance && isElligableForTrial ? '100% !important' : null
  },
  content: {
    height: '100%',
    padding: () => Spacing(0, 8)
  },
  logo: {
    cursor: 'pointer',
    width: 32,
    height: 32
  },
  [`${MediaQueries.desktop}`]: {
    logo: {
      padding: () => Spacing(0, 3, 0, 0)
    },
    content: {
      padding: () => Spacing(0, 4)
    }
  }
})
